import { requestPppLayer } from '../util/ppp'
import { hasTrackFreeFeature } from '../util/tcf-api'
import * as logger from '@mamdev/navigator.frontend-logger'
import { initForm, showForm } from '../form'
import { showMessage } from '../message-box'
import { getBrand } from '../util/brand'
import { getMonitoringService } from '../util/monitoring'
import { getAppUrl } from '../util/app-url'

export async function handleLogin(accessToken: string) {
  const result = await requestPppLayer(accessToken)
  if (!result) {
    showMessage()
    return
  }

  let hasTrackFree: boolean
  try {
    hasTrackFree = await hasTrackFreeFeature()
  } catch (e) {
    showMessage()
    return
  }

  getMonitoringService()?.monitorTrackFreeVerified(hasTrackFree)
  getMonitoringService()?.flush()

  if (hasTrackFree) {
    showMessage({
      type: 'success',
      head: 'Eingabe bestätigt',
      body: '<p>Vielen Dank, sie können diese Seite nun schließen.</p>'
    })
    logger.debug('TCString set')
  } else {
    logger.debug('TCString not set')
    const brandName = getBrand() === 'web.de' ? 'WEB.DE' : 'GMX'
    initForm(accessToken)
    showForm()
    showMessage({
      type: 'error',
      head: 'Dieser Account hat noch kein TrackFree-Abo',
      body: `<p>Für den angegebenen Account wurde kein TrackFree-Abo erkannt. Bitte überprüfen Sie, ob Sie sich mit dem richtigen ${brandName}-Konto eingeloggt haben.</p>
<p>Falls Sie Werbe- und / oder Script-Blocker installiert haben sollten, kann dies zu fehlerhaften Informationen bei der Anmeldung führen. Wir bitten Sie in diesem Fall diese temporär zu deaktivieren und den <a href="${getAppUrl()}" class="lux-link">Vorgang zu wiederholen</a>.</p>
<p>Alternativ können Sie auch jetzt ein TrackFree-Abo für diesen Account abschließen:</p>`
    })
  }
}
